import fields from '@/sui/data/sheets/edit/fields'
import intub from '@/sui/data/sheets/edit/intub'

function buildMicroOrgsArray (virus, atbv, v) {
  const mo = virus ? microOrgsAndViruses(atbv) : microOrgs(atbv)

  const isMoDetail = !['v1', 'v2', 'v3', 'v4'].includes(v)
  if (isMoDetail) {
    mo.push({ field: fields.microOrgDetail })
  }

  return {
    field: fields.microOrganisms,
    cfield: fields.microOrg,
    array: mo
  }
}

function microOrgs (atb) {
  return [
    { field: fields.microOrgCode, special: 'microOrgs' },
    { field: fields.explaurID },
    { field: fields.antibio, special: atb }
  ]
}

function microOrgsAndViruses (atb) {
  return [
    { field: fields.microOrgCode, special: 'microOrgsAndViruses' },
    { field: fields.antibio, special: atb }
  ]
}

const bmrBhreMicroOrgs = [
  { field: fields.microOrgCode }
]

function addV2 (f) {
  return { field: `${f}_v2`, cfield: f }
}

const bacteremia = (function () {
  function build (v, atb) {
    const c = [
      addV2(fields.entrance),
      { field: fields.diagDate, special: 'date' },
      { field: fields.divDiag },
      { field: fields.covidStatus },
      { field: fields.lipids },
      { field: fields.urinaryStart, special: 'date' },
      { field: fields.urinaryRemoved },
      { field: fields.urinaryEnd, special: 'date' },
      { field: fields.urinaryDiag },
      { field: intub.fields.bact.intubated },
      { field: intub.fields.bact.intubStart, special: 'date' },
      addV2(fields.enfCatheterType)
    ]

    const fv = {
      v1: [
        { field: fields.entrance },
        { field: fields.enfCatheterType }
      ],
      v2: [
        ...c,
        { field: fields.urinary },
        { field: fields.neoDivDiag }
      ],
      v3: [
        ...c,
        addV2(fields.urinary),
        { field: fields.previousManip },
        { field: fields.previousManipType },
        { field: fields.previousManipDate, special: 'date' },
        { field: fields.enfPreviousManip },
        { field: fields.enfPreviousManipType },
        { field: fields.enfPreviousManipDate, special: 'date' },
        { field: fields.clinicalSigns },
        { field: fields.bioSigns },
        { field: fields.adaptedAntibio },
        { field: fields.twoHemocs },
        { field: intub.fields.bact.reintubated },
        { field: intub.fields.bact.intubEnd, special: 'date' }
      ],
      v4: [
        ...c,
        addV2(fields.urinary),
        { field: fields.episodImmuno },
        { field: fields.previousManip },
        { field: fields.previousManipType },
        { field: fields.previousManipDate, special: 'date' },
        { field: fields.enfPreviousManip },
        { field: fields.enfPreviousManipType },
        { field: fields.enfPreviousManipDate, special: 'date' },
        { field: fields.clinicalSigns },
        { field: fields.bioSigns },
        { field: fields.adaptedAntibio },
        { field: fields.twoHemocs },
        { field: intub.fields.bact.reintubated },
        { field: intub.fields.bact.intubEnd, special: 'date' }
      ],

      v5: [
        ...c,
        addV2(fields.urinary),
        { field: fields.episodImmuno },
        { field: fields.previousManip },
        { field: fields.previousManipType },
        { field: fields.previousManipDate, special: 'date' },
        { field: fields.enfPreviousManip },
        { field: fields.enfPreviousManipType },
        { field: fields.enfPreviousManipDate, special: 'date' },
        { field: fields.clinicalSigns },
        { field: fields.bioSigns },
        { field: fields.adaptedAntibio },
        { field: fields.twoHemocs },
        { field: fields.tunneled },
        { field: fields.enfTunneled },
        { field: intub.fields.bact.reintubated },
        { field: intub.fields.bact.intubEnd, special: 'date' }
      ]
    }

    return [
      { field: fields.present, cfield: fields.bacteremia },
      { field: fields.episod, special: 'date' },
      { field: fields.origin, cfield: fields.bactOrigin },

      { field: fields.insertion, special: 'date' },
      {
        field: fields.insertion,
        cfield: fields.enfInsertionDate,
        special: 'date'
      },
      { field: fields.insertionSite },
      { field: fields.removed },
      { field: fields.removal, special: 'date' },
      { field: fields.enfCatheter },
      ...fv[v],
      buildMicroOrgsArray(false, atb, v)
    ]
  }

  return {
    v1: build('v1', 'antibio'),
    v2: build('v2', 'antibio'),
    v3: build('v3', 'antibio'),
    v4: build('v3', 'antibio_v2'),
    v5: build('v4', 'antibio_v2'),
    v6: build('v5', 'antibio_v2')
  }
})()

export default {
  bacteremia: bacteremia,

  specialMicroOrgs: {
    noVirus: {
      v1: buildMicroOrgsArray(false, 'antibio'),
      v2: buildMicroOrgsArray(false, 'antibio_v2'),
      v3: buildMicroOrgsArray(false, 'antibio_v2', 'v5')
    },
    virus: {
      v1: buildMicroOrgsArray(true, 'antibio'),
      v2: buildMicroOrgsArray(true, 'antibio_v2'),
      v3: buildMicroOrgsArray(true, 'antibio_v2', 'v5')
    }
  },

  addV2: addV2,
  bmrBhreMicroOrgs: bmrBhreMicroOrgs
}
